import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import Badge from "@mui/material/Badge";
import {useTranslation} from "react-i18next";
import {RightSidebarSearchButton} from "../../../layout/rightSidebar/RightSidebarRail";
import {ServerTableRailSearchPanel} from "../components/ServerTableRailSearchPanel";
import {useServerTableContext} from "../ServerTableContext";

export function ServerTableRailSearch() {
    const {t} = useTranslation();
    const {searchQuery} = useServerTableContext();

    return (
        <RightSidebarSearchButton
            icon={(
                <Badge
                    variant="dot"
                    invisible={!searchQuery.trim()}
                >
                    <SearchOutlinedIcon/>
                </Badge>
            )}
            label={t("Search")}
            renderPanel={close => <ServerTableRailSearchPanel onClose={close}/>}
        />
    );
}
